/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { reportsActions } from 'store/actions';
import { ReportsCalendar } from './reportsCalendar/ReportsCalendar';
import { IconButton } from 'components';
import { ChartIcon } from 'assets/icons';

import * as S from './ReportsHeader.styled';

export const ReportsHeader = memo(() => {
  const timePeriod = useSelector((state) => state.reports.selectedDateRangeReports);
  const isChartHidden = useSelector((state) => state.reports.isChartHiddenReports);
  const isChartDisabled = useSelector((state) => state.reports.isChartDisabledReports);
  const dispatch = useDispatch();

  const numOfDays = timePeriod ? getNumOfDays(timePeriod.from, timePeriod.to) : 0;

  return (
    <S.Header>
      <S.Title>Publishers Report</S.Title>
      <ReportsCalendar />
      <IconButton.NormalSize
        disabled={numOfDays > 180 || numOfDays < 2 || isChartDisabled}
        icon={ChartIcon}
        isPressed={!isChartHidden}
        type={IconButton.btnTypes.tertiary}
        onClick={() => {
          dispatch(
            reportsActions.updateProperty({
              propField: 'isChartHiddenReports',
              newValue: !isChartHidden,
            }),
          );
        }}
      />
    </S.Header>
  );
});

function getNumOfDays(from, to) {
  const fromDate = new Date(from);
  const toDate = new Date(to);

  return Math.floor((toDate - fromDate) / (24 * 60 * 60 * 1000)) + 1;
}

ReportsHeader.displayName = 'ReportsHeader';
